// Announcements on the start page: one short alert at a time, above the modes
// on PC and as a small pill on phones. The first one still running shows.
//
// For what players should know about: an app on the way, a tournament, an
// event night, downtime. Updates go in News instead (the bell gets a dot).
// Set `until` so it goes away by itself; closing it with × is remembered by
// its id on that device.
export type AnnouncementKind = "android" | "event" | "info";

export interface Announcement {
  id: string; // stable: a dismissal is remembered by it
  kind?: AnnouncementKind; // the icon and colour, "info" by default
  title: string; // short, it is one line
  text?: string; // one sentence more (PC only)
  link?: string; // a path ("/news/...") or a URL; without one it is not a link
  linkLabel?: string;
  until?: string; // YYYY-MM-DD, the last day it shows
}

export const ANNOUNCEMENTS: Announcement[] = [
  { id: "android-soon", kind: "android", title: "Will roll out to Android soon", text: "iPhone app will follow." },
  // { id: "tournament-2026-11", kind: "event", title: "Royale tournament on Saturday", text: "8 pm CET, a Royale every half hour, the best three nights win eggs.", link: "https://discord.gg/uqMGcrcJWN", linkLabel: "On Discord", until: "2026-11-08" },
];
